import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class BranchCategoryGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Branch Category',
            ROUTE_PATH.branchCategory,
            ROUTE_PATH.branchCategoryAdd,
            true,
            false,
            8,
            false,
            true,
            ['branchCatName'],
            false,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            null,
            false,
            false,
            false,
            null,
            { evalKey: 'wantToDelete', evalParam: [0], decisiveParam: false }
        )
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const branchCatName = new Headers('Branch Category', 'branchCatName', false, true, 'text');
        headers.push(branchCatName);
        return headers;
    }
}